"use client"

import { useEffect, useState } from "react"

import { serializeCartForBaback, type BabackCart } from "~/data/baback/serializer"
import useGetCart from "~/hooks/cart/useGetCart"

declare global {
  interface Window {
    baback: {
      onCartUpdate: (cart: BabackCart) => void
    }
  }
}

export default function Baback() {
  const {
    cart,
    cartArticlesNumber,
    totalPrice,
    totalDiscount,
    isFilledCart,
    cartWebUrl,
    currencyCode,
    cartQueryIsComplete,
    totalWeight,
  } = useGetCart()
  const [processed, setProcessed] = useState<BabackCart>({} as BabackCart)

  useEffect(() => {
    const cartValue = serializeCartForBaback({
      cart,
      cartArticlesNumber,
      totalPrice,
      totalDiscount,
      isFilledCart,
      cartWebUrl,
      currencyCode,
      cartQueryIsComplete,
      totalWeight,
    })
    if (
      JSON.stringify(processed) !== JSON.stringify(cartValue) &&
      typeof window !== "undefined" &&
      "baback" in window
    ) {
      console.log("cart", cartValue)
      setProcessed(cartValue)
      window?.baback?.onCartUpdate?.(cartValue)
    }
  }, [
    JSON.stringify(cart),
    cartArticlesNumber,
    totalPrice,
    isFilledCart,
    cartWebUrl,
    currencyCode,
    cartQueryIsComplete,
  ])

  return <></>
}
